import { MessageBox } from 'mint-ui'
import http from './http'
import router from '../router'

function appendThemeColorStyleNode (color) {
  var doc = document,
      mystyle = doc.createElement('style');
  mystyle.setAttribute('type', 'text/css');
  mystyle.innerHTML = '.theme-font-color{color:#'+color+';}.theme-bg-color{ background-color:#'+color+';}.theme-border-color{ border-color:#'+color+';}';
  doc.getElementsByTagName('head')[0].appendChild(mystyle);
}

function locationSearchParser (link) {
  var searchString  = link || window.location.search,
      searchString = searchString.substr(searchString.indexOf('?')),
      searchString = searchString.replace(/\?/g, ''),
      dict = {};
  if(searchString){
      var paramArr = searchString.split('&');
      for(var item in paramArr){
          var itemStr = paramArr[item];
          var pairArr = itemStr.split('=');
          dict[pairArr[0]] = pairArr[1];
      }
  }
  return dict;
}

var emotionsText = [];
function getEmotionsKey(callback){
    if(emotionsText.length) {
        if(callback){
            callback();
        }
        return ;
    }else{
        http.get('/mag/circle/v1/show/getEmotionsKey', {
            needLoadingIndicator: false,
        }, function (res) {
            if(res.success){
                emotionsText = res.list;
                if(callback){
                    callback();
                }
            }
        });
    }
}
getEmotionsKey();
function filterEmojImgsToText (content, callback){
    getEmotionsKey(function(){
        content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (src) {
            var text = '';
            src = src.replace(/face_[0-9]+\.png/g, function(item){
                var value = item.replace('face_','');
                if(emotionsText[parseInt(value)]){
                    text = '{:'+emotionsText[parseInt(value)]+':}';
                }
            });
            return text;
        });
        if(callback){
            callback(content);
        }
    });
}

function filterEmojTextToImg (content, callback){
    if(!content) return;
    getEmotionsKey(function () {
      content = content.replace(/{:[\u4e00-\u9fa5]+:}/g, function(text){
        var res = '';
        text.replace(/[\u4e00-\u9fa5]+/g, function(item){
          for(var i=0; i<emotionsText.length; i++){
            if(emotionsText[i] === item){
              if( i < 10 ){
                i = '00'+i;
              }else if( 10 <= i < 100 ){
                i = '0'+i;
              }
              //var src = 'http://demo.magapp-x.magcloud.cc/public/emotion/face_'+i+'.png';
              var src = window.location.origin+'/public/emotion/face_'+i+'.png';
              res = '<img class="img-emoj" src="'+src+'">';
            }
          }
        });
        return res;
      });
      if(callback){
        callback(content);
      }
    });
}

var appVersion = window.navigator.appVersion.toLowerCase();
var clientSystemType = {
    isIOS: appVersion.indexOf('iphone') != -1,
    isAndroid: appVersion.indexOf('android') != -1,
    isInMagappX: appVersion.indexOf('magappx') != -1,
    isWx: appVersion.indexOf('micromessenger') != -1,
};

const API_WSHARE_DETAIL = '/mag/circle/v1/show/wapShowView';
const API_FORUM_DETAIL = '/mag/circle/v1/forum/threadWapPage';
const API_INFO_DETAIL = '/mag/info/v1/info/wapInfoView';
const API_PORTAL_INFO_DETAIL = '/mag/info/v1/portalInfo/wapInfoView';


export default {
    clientSystemType: clientSystemType,
    setShareData (options){
      var shareTitle = options ? options.title : window.ShareTitle,
          shareDesc = options ? options.desc : window.ShareDesc,
          shareLink = window.location.href,
          shareImg = options ? options.img : window.ShareIcon;
      http.get('/mag/user/v1/wxwap/getSignPackage', {
        needLoadingIndicator: false,
        url: location.href.split('#')[0]
      }, function (res) {
        if(res.success){
          wx.config({
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','previewImage','scanQRCode']
          });
          wx.ready(function(){
              wx.onMenuShareTimeline({
                  title: shareTitle,
                  link: shareLink,
                  imgUrl: shareImg
              });
              wx.onMenuShareAppMessage({
                  title: shareTitle,
                  desc: shareDesc,
                  link: shareLink,
                  imgUrl: shareImg
              });
          });
          wx.error(function(res){
              //alert('对接公众平台出错：'+JSON.stringify(res));
          });
        }
      });
    },

    initRem (){
        var docEl = document.documentElement,
            clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        if( clientWidth > 640 ){
            docEl.style.fontSize = 10 + 'px';
        }else{
            docEl.style.fontSize = 10 * (clientWidth / 320) + 'px';
        }
    },

    appendThemeColorStyleNode: appendThemeColorStyleNode,

    locationSearchParser: locationSearchParser,

    filterEmojTextToImg: filterEmojTextToImg,

    pageIsInThirdPlatform (){
      var ua = window.navigator.userAgent.toLowerCase(),
          platqq = 'qq/',
          platweibo = 'weibo',
          platwx = 'micromessenger',
          res = false;
      if(ua.indexOf(platwx)!= -1 || ua.indexOf(platqq)!= -1 || ua.indexOf(platweibo)!= -1 ){
          res = true;
      }
      return res;
    },

    /* 功能修复0925 微信wap页点击右上角的立即打开，微信中直接跳应用宝或APP store， 浏览器中依旧弹框提示用户打开或下载客户端 */
    jumpToAppPage (jumpurl) {
      var jumpurl = jumpurl || '';
      var protocol = window.AppJumpProtocol;
      var currentHref = encodeURIComponent(window.location.href),
          jumpPath = encodeURIComponent(jumpurl),
          jumpUrlForWeixin = 'https://api.magcloud.cc/magshare/'+protocol+'?content_url='+currentHref+'&jump_url='+jumpPath;
      if(this.pageIsInThirdPlatform()){
          if(clientSystemType.isAndroid){
              $('.app-jump-overlay').fadeIn('fast', function () {
                $(this).find('.button-installed').attr('href', protocol+'://pagejump?jump_url='+jumpPath);
              });
          }else{
              window.location.href = jumpUrlForWeixin;
          }
      }else{
          $('.app-jump-overlay').fadeIn('fast', function () {
            $(this).find('.button-installed').attr('href', protocol+'://pagejump?jump_url='+jumpPath);
          });
      }
    },

    goLogin (){
      if(clientSystemType.isWx){
        window.location.href = '/mag/user/v1/wxwap/toWeiXinAuthorLogin?return_url='+encodeURIComponent(window.location.href);
      }else{
        //wap登陆注册页面
        router.push({
          name: 'UserLogin',
        });
      }
    },

    goShowDetail (id){
      window.location.href = API_WSHARE_DETAIL+'?content_id='+id+'&themecolor='+window.AppThemeColor;
    },

    goForumDetail (id, circle_id){
      window.location.href = API_FORUM_DETAIL+'?tid='+id+'&circle_id='+circle_id+'&themecolor='+window.AppThemeColor;
    },

    goDetailFromIndex (link){
      var url = '',
          me = this,
          params = locationSearchParser(link);
      if(link.indexOf('http') !== -1){
        url = link;
      }
      if(link.indexOf('://showView') !== -1){
        url = API_WSHARE_DETAIL+'?content_id='+params.id+'&themecolor='+window.AppThemeColor;
      }
      if(link.indexOf('/mag/circle/v1/forum/threadViewPage') !== -1){
        url = API_FORUM_DETAIL+'?tid='+params.tid+'&circle_id='+params.circle_id+'&themecolor='+window.AppThemeColor;
      }
      if(link.indexOf('/mag/info/v1/info/infoView') !== -1){
        url = API_INFO_DETAIL+'?id='+params.id+'&themecolor='+window.AppThemeColor;
      }
      if(link.indexOf('/mag/info/v1/portalInfo/infoView') !== -1){
        url = API_PORTAL_INFO_DETAIL+'?id='+params.id+'&themecolor='+window.AppThemeColor;
      }
      if(url){
        window.location.href = url;
      }else{
        MessageBox({
          title: '提示',
          message: 'QQ／微信内暂不能查看，前往客户端查看',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          if(action === 'confirm'){
            me.jumpToAppPage(url);
          }
        });
      }
    },

    toolItemJump (link){
      var me = this;
      var params = locationSearchParser(link);
      // 跳转到频道页面
      if(link.indexOf('channelList') >=0 ){
        router.push({
          name: 'Channel',
          query: {
            channel_id: params.channel_id
          }
        });
        return;
      }
      if(link && link.indexOf('http') >=0 ){
        if(link.indexOf('threadViewPage') !== -1){
          link = link.replace('threadViewPage', 'threadWapPage');
        }
        if(link.indexOf('infoView') !== -1){
          link = link.replace('infoView', 'wapInfoView');
        }
        if(link.indexOf('showView') !== -1){
          link = API_WSHARE_DETAIL+'?content_id='+params.id;
        }
        if(link.indexOf('?') < 0){
          link = link+'?themecolor='+window.AppThemeColor;
        }else{
          link = link+'&themecolor='+window.AppThemeColor;
        }
        window.location.href = link;
      }else{
        MessageBox({
          title: '提示',
          message: 'QQ／微信内暂不能查看，前往客户端查看',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          if(action === 'confirm'){
            me.jumpToAppPage(link);
          }
        });
      }
    },

    setTabPageTitle (){
      document.title = $('.btm-tabbar .item.router-link-exact-active').attr('naviname') || '';
    },

    getThirdPageLink (){
      var link = $('.btm-tabbar .item.router-link-exact-active').attr('thirdlink') || '';
      return decodeURIComponent(link);
    },

    setupScroller (options){
      var timer = null;
      options.listCopyed[0].innerHTML = options.listOri[0].innerHTML;
      if(options.listContainer[0].parentElement){
        timer = setInterval(function(){
          if(options.listContainer[0].parentElement.scrollTop == options.listOri[0].offsetHeight){
            options.listContainer[0].parentElement.scrollTop = 0;
          }else{
              options.listContainer[0].parentElement.scrollTop++;
          }
        }, 50);
      }
      return timer;
    }
    
}



// WEBPACK FOOTER //
// ./src/common/utils.js